import CreateControl from './CreateControl';
import ControlConfig from './ControlConfig';
import HubConfig from './HubConfig';

export default {
  createControl: CreateControl,
  controlConfig: ControlConfig,
  hubConfig: HubConfig,
};
